import { render } from "./IconStarRate.vue?vue&type=template&id=768f6f96"
import script from "./IconStarRate.vue?vue&type=script&lang=js"
export * from "./IconStarRate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__